import { buildApiUrl, fetchJSON, validateRequiredParams } from './crmApi';

export interface OrganizationMember {
  id: string;
  organization_id: string;
  user_id: string;
  role: 'owner' | 'admin' | 'member' | 'sales_manager' | 'sales_rep';
  created_at: string;
}

const organizationMembersService = {
  async list(organization_id: string): Promise<{ data: OrganizationMember[] }>{
    validateRequiredParams({ organization_id }, ['organization_id'], {
      service: 'organizationMembersService.list'
    });
    const url = buildApiUrl(`/api/crm/organizations/${encodeURIComponent(organization_id)}/members`);
    return fetchJSON(url, {
      description: 'List organization members',
      context: { organization_id }
    });
  },
  async add(organization_id: string, user_id: string, role: OrganizationMember['role'] = 'sales_rep'): Promise<{ data: OrganizationMember }>{
    validateRequiredParams({ organization_id, user_id, role }, ['organization_id', 'user_id', 'role'], {
      service: 'organizationMembersService.add'
    });
    const url = buildApiUrl(`/api/crm/organizations/${encodeURIComponent(organization_id)}/members`);
    return fetchJSON(url, {
      method: 'POST',
      body: { user_id, role },
      description: 'Add organization member',
      context: { organization_id, user_id, role }
    });
  },
  async update(organization_id: string, id: string, role: OrganizationMember['role']): Promise<{ data: OrganizationMember }>{
    validateRequiredParams({ organization_id, id, role }, ['organization_id', 'id', 'role'], {
      service: 'organizationMembersService.update'
    });
    const url = buildApiUrl(`/api/crm/organizations/${encodeURIComponent(organization_id)}/members/${encodeURIComponent(id)}`);
    return fetchJSON(url, {
      method: 'PUT',
      body: { role },
      description: 'Update organization member role',
      context: { organization_id, id, role }
    });
  },
  async remove(organization_id: string, id: string): Promise<{ success: boolean }>{
    validateRequiredParams({ organization_id, id }, ['organization_id', 'id'], {
      service: 'organizationMembersService.remove'
    });
    const url = buildApiUrl(`/api/crm/organizations/${encodeURIComponent(organization_id)}/members/${encodeURIComponent(id)}`);
    return fetchJSON(url, {
      method: 'DELETE',
      description: 'Remove organization member',
      context: { organization_id, id }
    });
  }
};

export default organizationMembersService;
